// extracted by mini-css-extract-plugin
module.exports = {"recap":"RecapSection_recap__21j0K","label":"RecapSection_label__d2wX_","value":"RecapSection_value__23rfV","subLabel":"RecapSection_subLabel__3iIh1"};